import { WebPushNotificationManager } from '@/common/notifications';
import { getCurrentUserRoles } from '@/hooks/use-current-user';
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { RoleName } from '../../../../backend/src/types.generated';

export const Route = createFileRoute('/_app')({
	component: AppLayout,
	beforeLoad: async ({ context }) => {
		const roles = await getCurrentUserRoles(context.apolloClient);

		if (roles?.length === 0) {
			throw redirect({
				to: '/auth/login',
				search: {
					redirect: location.href,
				},
			});
		}

		if (!roles?.some((role) => role.name === RoleName.User)) {
			if (roles?.some((role) => role.name === RoleName.Facility)) {
				throw redirect({ to: '/facility' });
			}

			if (roles?.some((role) => role.name === RoleName.Council)) {
				throw redirect({ to: '/council' });
			}
		}
	},
});

function AppLayout() {
	return (
		<>
			<WebPushNotificationManager />
			<Outlet />
		</>
	);
}
